const firebase = 'https://firebasestorage.googleapis.com/';
const firebaseProject = 'v0/b/api-project-284176342499.appspot.com/o/';
const COMPANY_NAME_SLUG = 'biwiser';
const ENV = 'prod';    // las opciones admitidas [dev, stage, prod]

export const environment = {
  production: true,    // true o false
  name: ENV,
  apiUrl: 'https://api.biwiser.com/api/v1/',
  testUser: {
    email: '',
    password: '',
  },
  firebaseConfig: {
    apiKey: 'AIzaSyAMkz-3Ixa-0aVBzQesAlwgk9nF5MxHvYc',
    authDomain: 'api-project-284176342499.firebaseapp.com',
    databaseURL: 'https://api-project-284176342499.firebaseio.com/',
    projectId: 'api-project-284176342499',
    storageBucket: 'api-project-284176342499.appspot.com',
    messagingSenderId: '284176342499',  // FCM
  },
  buckets: {
    companyImages: `${COMPANY_NAME_SLUG}/${ENV}/empresas/`,
    workbookImages: `${COMPANY_NAME_SLUG}/${ENV}/reportes/`,
    viewImages: `${COMPANY_NAME_SLUG}/${ENV}/vistas/`,
    snapshots: `${COMPANY_NAME_SLUG}/${ENV}/snapshots/`,
  },
  platformInfo: {
    name: `${COMPANY_NAME_SLUG}`,
    companyName: `${COMPANY_NAME_SLUG}`,
    pathLogo: `${firebase}${firebaseProject}companies%2Flogin_logo.png?alt=media&token=b57dd8a0-8f79-4721-92f5-3f52101a8d58`,
    version: 1.0,
  },
  firebaseStorage: `${firebase}${firebaseProject}`,
  refreshTokenInterval: 1700000,
  TableauSiteRoles: {
    Creator: 'Creator',
    Explorer: 'Explorer',
    ExplorerCanPublish: 'ExplorerCanPublish',
    SiteAdministratorExplorer: 'SiteAdministratorExplorer',
    SiteAdministratorCreator: 'SiteAdministratorCreator',
    Unlicensed: 'Unlicensed',
    Viewer: 'Viewer'
  }
};
